import { z } from "zod";
/**
 * Optional retrieval scope. Default = whole org. Either narrow to specific
 * repos or to a single team's repos.
 */
export const QaScope = z.object({
    repoIds: z.array(z.string().uuid()).optional(),
    teamId: z.string().uuid().nullable().optional(),
});
export const QaRequest = z.object({
    question: z.string().min(1),
    /** Optional — when provided, append the new turn to this conversation. */
    conversationId: z.string().uuid().optional(),
    scope: QaScope.optional(),
});
export const QaCitationSourceType = z.enum([
    "ticket",
    "test_case",
    "file_chunk",
    "repo_spec",
    /** A whole repo, surfaced because the QA pass invoked a cross-repo graph
     *  tool that returned (or referenced) this repo. Links to the Service map. */
    "repo",
]);
export const QaChunk = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("conversation"),
        conversationId: z.string().uuid(),
        title: z.string(),
        isNew: z.boolean(),
    }),
    z.object({ type: z.literal("token"), text: z.string() }),
    z.object({
        type: z.literal("citation"),
        sourceType: QaCitationSourceType,
        sourceId: z.string(),
        label: z.string(),
    }),
    z.object({ type: z.literal("error"), message: z.string() }),
    z.object({ type: z.literal("done") }),
]);
export const ConversationSummary = z.object({
    id: z.string().uuid(),
    title: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    messageCount: z.number().int().nonnegative(),
});
export const ConversationsListResponse = z.object({
    conversations: z.array(ConversationSummary),
});
export const ConversationMessageDto = z.object({
    id: z.string().uuid(),
    role: z.enum(["user", "assistant"]),
    content: z.string(),
    citations: z.array(z.object({
        sourceType: QaCitationSourceType,
        sourceId: z.string(),
        label: z.string(),
    })),
    createdAt: z.string().datetime(),
});
export const ConversationDetailResponse = z.object({
    conversation: ConversationSummary,
    messages: z.array(ConversationMessageDto),
});
export const ConversationIdParam = z.object({
    id: z.string().uuid(),
});
export const ConversationDeleteResponse = z.object({
    deleted: z.literal(true),
});
//# sourceMappingURL=qa.js.map